module.exports = __webpack_public_path__ + "img/4.b5e7de78.jpg";